import React from "react";
import classnames from "classnames";

import { HStack } from "@formant/ui/component/common/HStack";

import { appStore } from "../../../stores";
import { formatTime } from "../../../utils/formatTime";
import { DeviceName } from "../../common/DeviceName";
import { Linkify } from "../../common/Linkify";
import { Tags } from "../../common/Tags";
import { DeepPureComponent } from "../../DeepPureComponent";
import { IMetadataDataPoint } from "../utils/IMetadataDataPoint";
import * as styles from "./TextModuleListItem.scss";

export interface ITextModuleListItemProps {
    point: IMetadataDataPoint<"text">;
    old: boolean;
    live: boolean;
    hideDevice?: boolean;
    utc: boolean;
    onClick: (point: IMetadataDataPoint<"text">) => void;
    selected: boolean;
}

export class TextModuleListItem extends DeepPureComponent<ITextModuleListItemProps> {
    public render() {
        const { onClickRow } = this;
        const { point, old, live, hideDevice, selected } = this.props;
        const { value, time, deviceId, tags } = point;

        return (
            <div
                className={classnames(
                    styles["text-module-list-item"],
                    !old && styles.current,
                    !old && live && styles.live,
                    selected && styles.selected,
                )}
                onClick={onClickRow}
                onMouseEnter={this.onHover}
                onMouseLeave={this.onLeave}
                onMouseMove={this.onHover}
            >
                <HStack hAlign="space-between">
                    {!hideDevice && (
                        <div className={styles.device}>
                            <DeviceName id={deviceId} size="18" />
                        </div>
                    )}
                    <div className={styles.time}>
                        {formatTime(time, { milliseconds: false })}
                    </div>
                </HStack>
                <HStack className={styles.text} vAlign="center">
                    <Linkify text={value} />
                </HStack>

                {!hideDevice && <Tags tags={tags} className={styles.tags} />}
            </div>
        );
    }

    private onHover = (e: React.MouseEvent<HTMLTableRowElement>) => {
        const { deviceId, tags, time } = this.props.point;
        appStore.valueTooltip = {
            x: e.pageX,
            y: e.pageY,
            deviceId,
            tags,
            time,
        };
    };

    private onLeave = () => {
        appStore.valueTooltip = undefined;
    };

    private onClickRow = () => {
        const { point, onClick } = this.props;
        onClick(point);
    };
}
